$(document).ready(function () {
	// $('.btn-download').on('click',function (e) {
	// 	e.preventDefault();
	// 	var width=$(window).width();
	// 	var images=[];
	// 	$.each($('.product-img'),function (index,img) {
	// 		var image=$(img)
	// 		if (width>768) {
	// 			images.push(image.find('.zoomImg').attr('src'))
	// 		}
	// 		else{
	// 			images.push(image.find('.product-images').attr('src'))
	// 		}
	// 	})
	// 	console.log(images)
	// 	var urls=[];
	// 	$.each(images,function (index,img) {
	// 		if (img!=undefined && img!='' && img!=null) {
	// 			urls.push(img)
	// 		}
	// 	})
	// 	console.log(urls)
	// 	var zip = new JSZip();
	// 	var count = name= 0;
	// 	var zipFilename = "images.zip";
	// 	urls.forEach(function(url){
	// 	  name++;
	// 	  var filename = url.split('.').pop();
	// 	  var extention=filename.split('?')
	// 	  filename=name+'.'+extention[0]
	// 		console.log(filename)
		  
	// 	  // loading a file and add it in a zip file
	// 	  JSZipUtils.getBinaryContent(url, function (err, data) {
	// 	     if(err) {
	// 	        throw err; // or handle the error
	// 	     }
	// 	     zip.file(filename, data, {binary:true});
	// 	     count++;
	// 	     if (count == urls.length) {
	// 	     	zip.generateAsync({type:"base64"}).then(function (base64) {
	// 			    location.href="data:application/zip;base64," + base64;
	// 			});
	// 	     }
	// 	  });
	// 	});
	// })
	$('.social-sharing__link.print').click(function () {
		window.print()
	})
	$('.btn-enquire.single-product').on('click',function () {
		var product=$(this)
		var title=product.attr('data-product')
		var form_title='SEND AN ENQUIRY FOR '+title
		var form_message='Dear Sirs, Please send an offer for following machine: '+title
		$('#form-contact-product .block-title').html(form_title)
		$('#form-contact-product #contactFormMessage').html(form_message)
		$('#form-contact-product').addClass('active')
	})
	$('.btn-enquire.multiple-product').on('click',function () {
		var products =''
		$.each($('.wishlist-card'),function (index,card) {
			var html=$(card)
			products+=' '+$(html).find('.product-name a').html()+','
		})
		var form_title='SEND AN ENQUIRY FOR WISHLIST'
		var form_message='Dear Sirs, Please send an offer for following machine: '+products.substring(0, products.length - 1)
		$('#form-contact-product .block-title').html(form_title)
		$('#form-contact-product #contactFormMessage').html(form_message)
		$('#form-contact-product').addClass('active')
	})
	$('.vpp-close').on('click',function () {
		$('#form-contact-product').removeClass('active')
		var original_form_title=$('#form-contact-product #original-form-title').val()
		var original_form_message=$('#form-contact-product #original-form-message').val()
		$('#form-contact-product .block-title').html(original_form_title)
		$('#form-contact-product #contactFormMessage').html(original_form_message)
	})
	// $('.product-layout__classic .refference').html('Ref: '+Math.floor((Math.random() * 1000000) + 1))
})